<template>
  <footer class="app-footer bg-blur">
    <div class="container">
      <div class="small-content">
        <div class="top-row flex items-center w-full gap-8">
          <div class="top-row-left-col flex items-center gap-8 w-full">
            <AppLogo
              height="38"
              :is-image-visible="false"
            />
            <div class="divider" />
            <ClientOnly>
              <DocumentLinks />
            </ClientOnly>
          </div>
          <ClientOnly>
            <div class="flex items-center gap-4">
              <NuxtLink
                external
                rel="nofollow"
                target="_blank"
                to="https://discord.com/"
                :aria-label="getContent('footer.link_discord_aria_label')"
              >
                <AppIcon name="discord_icon" />
              </NuxtLink>
              <NuxtLink
                external
                rel="nofollow"
                target="_blank"
                to="https://x.com/"
                :aria-label="getContent('footer.link_x_com_aria_label')"
              >
                <AppIcon name="x_com_icon" />
              </NuxtLink>
            </div>
          </ClientOnly>
        </div>
        <p class="footer-description">
          <!-- {{ getContent('footer.description') }} -->
        </p>
        <div class="bottom-row flex justify-between items-center gap-5">
          <p class="bottom-row-left-col footer-bottom-text text-white">
            {{ getContent('footer.copyright', { year }) }}
          </p>
          <div class="bottom-row-right-col flex items-center gap-8">
            <NuxtLink
              to="/privacy-policy"
              rel="nofollow"
              :aria-label="getContent('footer.link_privacy_policy_aria_label')"
              class="footer-bottom-text text-white footer-link"
            >
              {{ getContent('footer.link_privacy_policy') }}
            </NuxtLink>
            <NuxtLink
              to="/terms-of-service"
              rel="nofollow"
              :aria-label="getContent('footer.link_terms_of_use_aria_label')"
              class="footer-bottom-text text-white footer-link"
            >
              {{ getContent('footer.link_terms_of_use') }}
            </NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data: () => ({
    year: new Date().getFullYear(),
  }),
};
</script>

<style lang="scss" scoped>
.app-footer {
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 10;
  position: absolute;
  padding: 65px 0;

  .top-row {
    flex-direction: row;
    justify-content: space-between;

    .top-row-left-col {
      flex-direction: row;
    }
  }

  .footer-description {
    color: $gray-100;
    font-size: 12px;
    line-height: 18px;
    margin: 32px 0;
  }

  .divider {
    width: 1px;
    height: 38px;
    background-color: $gray-200;
  }

  .bottom-row {
    flex-direction: row;

    .bottom-row-left-col {
      order: 1;
    }

    .bottom-row-right-col {
      order: 2;
    }

    .footer-bottom-text {
      font-size: 14px;
      line-height: 24px;
    }

    .footer-link {
      text-decoration: underline;
      transition: .2s linear;

      &:hover {
        color: $yellow-100;
      }
    }
  }
}

@media only screen and (max-width: $sm) {
  .app-footer {
    padding: 65px 0 20px;

    .top-row {
      flex-direction: column;

      .top-row-left-col {
        flex-direction: column;
      }
    }

    .divider {
      width: 100%;
      height: 1px;
    }

    .bottom-row {
      flex-direction: column;

      .bottom-row-left-col {
        order: 2;
      }

      .bottom-row-right-col {
        order: 1;
      }
    }
  }
}
</style>
